<template>
  <div>
    <BuscadorTabla class="mt-3" :label="$t('Introducir descripcion')" @search_general="filter_servicio_combinado"/>

    <!-- Tabla de servicios -->
    <v-data-table
        :headers="headers"
        :loading="loading"
        :items="servicios_combinados"
        :options.sync="options"
        :server-items-length="count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
    >
      <!-- Columna de acciones -->
      <template v-slot:item.actions="{ item }">
        <v-btn icon color="primary" @click="open_dialog_servicio_combinado(item)" elevation="0" :title="$t('Editar')">
          <v-icon
          >mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <FormServicioCombinado
        v-if="dialog_servicio_combinado"
        :titulo="$t('Servicio combinado')"
        v-model="dialog_servicio_combinado"
        :item="current_servicio_combinado"
        @on_save="on_save_servicio_combinado"
    />
  </div>
</template>

<script>
// Importamos el evento global para abrir el dialog
import { EventBus } from '@/store/index.js';

export default {
  name: "ServiciosCombinados",
  data: () => ({
    // Servicio combinado actual
    current_servicio_combinado: null,
    filtros_tabla: {},
    // Filtros del buscador
    filtros_buscador: {
      search: ''
    },
    // Dialog servicio combinado
    dialog_servicio_combinado: false,
    loading: false,
    // Variables para la tabla
    servicios_combinados: [],
    count: 0,
    headers: [

    ],
    options: {
      itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
    }
  }),


  methods: {
    /**
     * Carga los servicios combinados
     * @returns {Promise<void>}
     */
    async get_servicios_combinados() {
      try {
        this.loading = true
        let filtros = {...this.filtros_tabla}

        // Preparamos los filtros del buscador
        filtros['descripcion'] = this.filtros_buscador.descripcion
        filtros['search'] = this.filtros_tabla['search']
        let data = await this.$store.dispatch('servicio_combinado/get_servicios_combinados', filtros)
        this.loading = false
        this.count = data.count
        this.servicios_combinados = data.results
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },
    /**
     * Abre el dialog del servicio combinado
     *
     * @param servicio_combinado
     */
    open_dialog_servicio_combinado(servicio_combinado) {
      this.current_servicio_combinado = {
        items: [],
        is_active: true
      }
      if(servicio_combinado && servicio_combinado.id) this.current_servicio_combinado = servicio_combinado

      this.dialog_servicio_combinado = true
    },

    on_save_servicio_combinado(){
      this.get_servicios_combinados()
      this.dialog_servicio_combinado = false
    },

    filter_servicio_combinado(filter){
      this.filtros_tabla['search'] = filter
      this.filtros_tabla['offset'] = 0
      this.options.page = 1

      this.get_servicios_combinados();
    }
  },
  // Observamos el campo
  watch: {
    options: {
      handler (value) {
        this.filtros_tabla['limit'] = value.itemsPerPage
        this.filtros_tabla['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.filtros_tabla['ordering'] = `${desc}${value.sortBy[0]}`
        }
        this.get_servicios_combinados()
      }
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t('Descripción'), value: 'descripcion', class: "primary white--text" },
      { text: '', value: 'actions', class: "primary white--text", sortable: false, align: "right", width: '10%' },
    ]
  },
  components: {
    FormServicioCombinado: () => import('@/views/Configuracion/Servicios/ServiciosCombinados/components/FormServicioCombinado'),
    BuscadorTabla: () => import("@/components/core/BuscadorTabla")
  }
}
</script>
